import { Box, Container, Typography } from "@mui/material";
import ActionCard from "app/frontend/components/ActionCard";
import { CARDS } from "app/frontend/components/static/incentives/incentive_cards";
import { FLEX_COLUMN_SX } from "app/frontend/styles/sx";
import { toId } from "app/frontend/utils/inputs";
import { PropsWithChildren } from "react";

const IncentivesCardGroup: React.FC<PropsWithChildren> = () => {
    return (
        <Container
            disableGutters
            sx={{
                ...FLEX_COLUMN_SX,
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#DBDBDB",
                minWidth: "100%",
                paddingX: { xs: 3, sm: "calc(300 * (100vw / 1600))" },
                paddingY: { xs: 3, sm: 20, md: 5 },
            }}
        >
            <Typography
                variant="h2"
                component={"h2"}
                color="common.black"
                paddingBottom={5}
                textAlign={"center"}
                minWidth={"100%"}
            >
                Everything You Need To Confirm You&apos;re On The Right Track
            </Typography>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: "20px" }}>
                {CARDS.map((card) => {
                    return <ActionCard key={toId(card.title)} card={card} />;
                })}
            </Box>
        </Container>
    );
};

export default IncentivesCardGroup;
